<script setup lang="ts">
  // Host of the one-time "you will be reminded" line, see useReminderHint. Mounted once, in app.vue.
  const {visible, dismiss} = useReminderHint();
</script>

<template>
  <div v-if="visible" class="wad4-reminder-hint">
    <CommonWadToast message="You'll get a reminder 15 minutes before it starts." :auto-dismiss="5000" @close="dismiss"/>
  </div>
</template>

<style lang="scss">
.wad4-reminder-hint {
  position: fixed;
  left: $wad4-container-spacing;
  right: $wad4-container-spacing;
  bottom: calc(#{$wad4-container-spacing} + env(safe-area-inset-bottom, 0px));
  z-index: 50;
  display: flex;
  justify-content: center;
  pointer-events: none;

  > * {
    pointer-events: auto;
    width: 100%;
    max-width: 420px;
  }
}
</style>
